import $ from 'jquery'
import _ from 'underscore'
import Backbone from 'backbone'
import Parse from 'parse'
import BaseParseObject from './BaseParseObject'
import ObservingList from './ObservingList'
import ObservingSession from './ObservingSession'

'use strict'

export const SkyObjectObservation = BaseParseObject.extend('SkyObjectObservation', {
  update: function (data) {
    const acl = new Parse.ACL()

    if (!this.get('ACL')) {
      acl.setPublicReadAccess(false)
      acl.setReadAccess(Parse.User.current().id, true)
      acl.setWriteAccess(Parse.User.current().id, true)
      this.setACL(acl)
    }

    this.set('user', Parse.User.current())
    this.set('beginJD', parseFloat(data.beginJD))
    this.set('endJD', parseFloat(data.endJD))
    this.set('comments', data.comments)
    this.set('faintestStar', parseFloat(data.faintestStar))
    this.set('seeing', parseFloat(data.seeing))
    this.set('skyQuality', parseFloat(data.skyQuality))

    if (Object.keys(data.equipment).length > 0) {
      this.set('equipment', data.equipment)
    } else {
      this.unset('equipment')
    }

    if (data.session) {
      // have to create a class instance when referring to a pointer type in Parse
      this.set('session', ObservingSession.createWithoutData(data.session))
    } else {
      this.unset('session')
    }

    if (data.observingList) {
      // have to create a class instance when referring to a pointer type in Parse
      this.set('observingList', ObservingList.createWithoutData(data.observingList))
    } else {
      this.unset('observingList')
    }

    // save the object
    return this.save().then(
      (item) => {
        Backbone.trigger('skyObjectObservations:updated', item)
      },
      (error) => {
        Backbone.trigger('errors:parseReturned', error)
      }
    )
  },

  delete: function () {
    this.set('deleted', true)
    return this.save().then(
      (result) => {
        Backbone.trigger('skyObjectObservations:deleted', result)
      },
      (error) => {
        Backbone.trigger('errors:parseReturned', error)
      }
    )
  },

  displayInSkySafariWidget: function (ssww) {
    if (!ssww) return

    const julianStart = this.get('beginJD')
    const session = this.get('session')
    const target = this.get('skyObject')
    const delimiter = '%%'
    let site
    let latDegrees
    let lngDegrees
    let targetObject
    let selectedSkyObject


    // Start with a clean slate
    ssww.reset()

    // Set Location to match
    if (session) {
      site = session.get('site')
      if (site) {
        latDegrees = site.get('location')._latitude
        lngDegrees = site.get('location')._longitude

        ssww.location.set({ latitude: latDegrees, longitude: lngDegrees })
      }
    }

    // Set Date to match
    if (julianStart) {
      ssww.dateTime.setJulianDate(julianStart)
    }

    // Select target and centre
    if (target) {
      targetObject = {
        file: parseInt(target.file),
        region: parseInt(target.region),
        index: parseInt(target.index),
        catnum: target.catnum ? target.catnum.toString() : undefined,
        name: target.name ? target.name.toString() : undefined,
        type: target.type ? target.type.toString() : undefined
      }
      // TODO: this is not working for stars?
      // There seems to be something wrong with the target file/region/index
      // ssww.skyObject.select(targetObject)
      selectedSkyObject = ssww.skyObject.selectFirstMatch(targetObject.name)
      if (!selectedSkyObject) {

        if (!_.isEmpty(target.catalogNumbers)) {
          selectedSkyObject = ssww.skyObject.selectFirstMatch(target.catalogNumbers.split(delimiter)[0])
        } else if (!_.isEmpty(target.commonNames)) {
          selectedSkyObject = ssww.skyObject.selectFirstMatch(target.commonNames.split(delimiter)[0])
        }
      }
      if (selectedSkyObject) ssww.skyObject.centerSelected()
    }
  }
})

export default SkyObjectObservation
